import { IconWrapper } from '../runtime';
export default IconWrapper('text-format', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 24 24",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 3.75C0 1.67893 1.67893 0 3.75 0H20.25C22.3211 0 24 1.67893 24 3.75V20.25C24 22.3211 22.3211 24 20.25 24H3.75C1.67893 24 0 22.3211 0 20.25V3.75Z",
      "fill": 'url(#' + props.id + '1efeb0d8' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "M6 5.625C5.58579 5.625 5.25 5.96079 5.25 6.375V7.125C5.25 7.53921 5.58579 7.875 6 7.875H10.875V18C10.875 18.4142 11.2108 18.75 11.625 18.75H12.375C12.7892 18.75 13.125 18.4142 13.125 18V7.875H18C18.4142 7.875 18.75 7.53921 18.75 7.125V6.375C18.75 5.96079 18.4142 5.625 18 5.625H6Z",
      "fill": "white"
    }
  }), h("defs", [h("linearGradient", {
    "attrs": {
      "id": props.id + '1efeb0d8',
      "x1": "0",
      "y1": "0",
      "x2": "24",
      "y2": "24",
      "gradientUnits": "userSpaceOnUse"
    }
  }, [h("stop", {
    "attrs": {
      "stop-color": "#8497B8"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#60718D"
    }
  })])])]);
});